// The no-reply follow-ups to quiet leads, in words. Days are Eastern, like the
// server that drafts them.

const TZ = "America/New_York";

export function easternDay(value) {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-CA", { timeZone: TZ });
}

function whenWords(value, nowMs = Date.now()) {
  const day = easternDay(value);
  const today = easternDay(new Date(nowMs));
  if (!day) return "";
  if (day <= today) return "today";
  if (day === easternDay(new Date(nowMs + 86400000))) return "tomorrow";
  return new Date(value).toLocaleDateString([], { timeZone: TZ, weekday: "short", month: "short", day: "numeric" });
}

export function campaignLine(lead, nowMs = Date.now()) {
  const c = lead.campaign;
  if (!c || !c.enabled) return "";
  const of = `${c.step} of ${c.total}`;
  if (c.status === "active") {
    const sent = c.step ? `${of} sent · ` : "";
    if (c.waiting_draft_id) return `${sent}email ${c.step + 1} is waiting for your approval`;
    return `${sent}email ${c.step + 1} drafted for you ${whenWords(c.next_at, nowMs)}`;
  }
  if (c.status === "stopped") return `Stopped: ${c.reason || "stopped"}${c.step ? ` (${of} sent)` : ""}`;
  if (c.status === "finished") return `All ${c.total} sent`;
  return lead.first_reply_at ? "" : "Starts when you first reply";
}
